module.exports = __webpack_public_path__ + "static/media/cu05_eng.401838a8.png";